import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils/unwrapResponse'
import { PostProject, Project } from '@/types/api/entities'
import { APIErrorResponse } from '@/types'
import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { getUseProjectKey } from '@/hooks/api/useProject'
import { QUERY_KEYS } from '@/constants'

export const usePostProject = (): UseMutationResult<
  Project,
  APIErrorResponse,
  PostProject
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (params) =>
      client
        .post(`projects/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: (data) => {
        const queryKey = getUseProjectKey(data.id)

        queryClient.setQueryData(queryKey, data)
        queryClient.invalidateQueries(QUERY_KEYS.PROJECTS)
      },
    }
  )
}
